var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { attrs: { id: "frm" } }, [
    _c(
      "div",
      {
        staticClass: "popup_wrap",
        staticStyle: {
          width: "600px",
          "max-height": "900px",
          "margin-top": "-80px",
        },
      },
      [
        _c(
          "button",
          {
            staticClass: "layer_close",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("close")]
        ),
        _c("div", { staticClass: "popup_cont" }, [
          _c("form", { attrs: { id: "frm" } }, [
            _c("div", { staticClass: "content_box" }, [
              _c("table", { staticClass: "tbl_row mt10" }, [
                _vm._m(0),
                _c(
                  "tbody",
                  [
                    _c("tr", [
                      _c("th", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(_vm._s(_vm.$t("msg.MYIN010G010.004"))),
                      ]),
                      _vm._v(" "),
                      _c("th", { staticStyle: { "text-align": "center" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("msg.ONEX010T010.166")) + " "
                        ),
                      ]),
                    ]),
                    _vm._l(_vm.sectionList, function (item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.fakChkYn,
                                expression: "item.fakChkYn",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: item.cd,
                              id: item.cd,
                              "true-value": "Y",
                              "false-value": "N",
                            },
                            domProps: {
                              checked: Array.isArray(item.fakChkYn)
                                ? _vm._i(item.fakChkYn, null) > -1
                                : _vm._q(item.fakChkYn, "Y"),
                            },
                            on: {
                              change: function ($event) {
                                var $$a = item.fakChkYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : "N"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        item,
                                        "fakChkYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        item,
                                        "fakChkYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(item, "fakChkYn", $$c)
                                }
                              },
                            },
                          }),
                          _c("label", {
                            staticStyle: { "margin-left": "35%" },
                            attrs: { for: item.cd },
                          }),
                        ]),
                        _c(
                          "td",
                          {
                            staticClass: "multi-line-css",
                            staticStyle: { "text-align": "center" },
                          },
                          [_vm._v(_vm._s(item.dsc))]
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "mt10 text_center" }, [
            _c(
              "a",
              {
                staticClass: "button blue lg",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onConfirm()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("btn.CMBTK013")))]
            ),
            _c(
              "a",
              {
                staticClass: "button gray lg",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("msg.MYIN020T020.046")))]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "15%" } }),
      _c("col", { staticStyle: { width: "auto" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }